export default __webpack_public_path__ + "static/media/nyc.01a0c372.jpg";